<template>
  <RouterLink :to="href ?? ''" :id="'nav-row-' + name">
    <li
      class="nav-item mt-1 nav-item-nested"
      :class="isExpanded ? ' justify-content-start' : 'd-flex flex-row justify-content-center'"
    >
      <div
        :class="[
          'nav-link ms-nav ',
          isExpanded ? 'justify-content-start' : 'justify-content-center ms-nav-sm'
        ]"
        class="d-flex flex-row rounded NKT-P2"
        :id="'nav-link-' + name"
      >
        <div class="ms-nested-nav-elm">
          <span :class="['ms-nav-text', { expanded: isExpanded }]">{{
            isExpanded ? name : ''
          }}</span>
        </div>
      </div>
    </li>
  </RouterLink>
</template>

<script setup lang="ts">
import { computed, defineProps, watch, defineEmits } from 'vue'
import { useRoute } from 'vue-router'

var props = defineProps({
  name: String,
  href: String,
  isExpanded: Boolean
})

const emit = defineEmits(['isActive'])

const route = useRoute()

const active = computed(() => {
  if (props.href === undefined || props.href === '/') {
    return route.path === '/'
  }

  var active = route.path.startsWith(props.href)

  return active
})

watch(
  () => active.value,
  (newVal) => {
    if (newVal) {
      emit('isActive', true)
    } else {
      emit('isActive', false)
    }
  }
)
</script>

<style scoped lang="scss">
@use '@/styles/ms-color-styles.scss' as color;

.ms-nav-sm {
  width: 56px;
}

.ms-nav {
  height: 42px;
}

.ms-nav-text {
  opacity: 0;
  transition: opacity 0.1s ease 0.2s;
}

.ms-nav-text.expanded {
  opacity: 1;
}

.nav-icon {
  width: 20px;
  height: 20px;
  margin-right: 0px;
}

.nav-icon.expanded {
  margin-right: 20px;
}

.navbar-expand-md .navbar-nav .nav-link.active:before {
  border-left: none;
}

.ms-nested-nav-elm {
  margin-left: 40px;
}

.router-link-active .ms-nav-text,
.nav-link.active .ms-nav-text {
  text-decoration: underline;
}

.navbar-nav .nav-item .nav-link:hover {
  background-color: color.$color-white !important;
}

.navbar-nav .nav-link.active,
.navbar-nav .nav-link.show,
.navbar-nav .nav-link:not(.active) {
  color: color.$color-black;
}

.nav-item-nested {
  height: 28px;
}
</style>
